<template>
  <b-container fluid >
    <b-row>
      <b-col md="12">
        <div class="iq-card p-3 row">
          <div class="col-12 col-sm-6 col-md-6 col-lg-6">
            <h4>
              <i class="fa fa-book-open-reader" aria-hidden="true" style="font-size: 21px; margin-right: 10px; color: var(--iq-primary); position: relative; top: 2px"></i>
              <span>{{ cvCardTitle }}</span>
            </h4>
          </div>
        </div>

        <tab-content-item :active="true" id="profile-all-organisations" aria-labelled-by="pills-all-organisations-tab">
          <div class="rounded p-3 bg-white iq-card row">
            <!-- Backend Search -->
            <b-col lg="10" class="mb-3">
              <b-form-input class="form-control"
                @input="searchCourseParams"
                v-model="whereFilter.search_param"
                type="search"
                :placeholder="cvSearchText"></b-form-input>
            </b-col><!-- Backend Search -->
            <div class="form-group col-12 col-sm-6 col-md-4 col-lg-3 mb-2">
              <multiselect
                v-model="selectedCourse"
                :options="cvcareerCourseOptions"
                :placeholder="cvSelectBoxText"
                label="cour_name"
                track-by="cour_name"
                ref="multiselectschool"
                :reduce="cour => cour.cour_name"
                @search-change="SearchcareerCourseList($event)"
                @input="setFilter('course', selectedCourse)"
              >
                <span slot="noResult">
                  No courses found
                </span>
              </multiselect>
            </div>
            <b-col class="col-12 col-sm-6 col-md-4 col-lg-3 mb-2">
              <select v-model="whereFilter.country" class="form-control" title="session states" @change="setFilter('country', whereFilter.country)">
                <option :value="null" disabled selected >Select Country</option>
                <option v-for="(country, index) in countryList" :key="index" :value="country.country">
                  {{ country.country }}
                </option>
              </select>
            </b-col>
            <b-col class="col-12 col-sm-12 col-md-4 col-lg-4 mb-3">
              <multiselect
                  v-model="orgName"
                  :options="cvUnivOptions"
                  :placeholder="cvSelectorg"
                  label="org_name"
                  track-by="org_name"
                  :reduce="org => org.org_name"
                  @search-change="organisationNameFilterList($event)"
                  @input="setFilter('university', orgName)"
                />
            </b-col>
          </div>
          <div v-if="Object.values(organisationListObj).length >0" >
            <b-row >
              <div v-for="(org,index) in organisationListObj" :key="index" class="mt-2 col-12 col-sm-6 col-md-4 col-lg-3">
                <iq-card className="iq-card-block iq-card-stretch iq-card-height side_border">
                  <template v-slot:body>
                    <div class="orgDetails" @click="goToOrganisationCourses(org.org_id)">
                      <p class="org_name"><b>{{org.cour_name}}</b></p>
                      <p class="org_name">{{org.org_name}}</p>
                      <p class="org_ra">NIRF Score: <span>{{org.org_rating}}</span> | Rank: <span>{{org.org_rank}}</span></p>
                      <p class="programs">
                        Degree:
                        <span v-if="org.cour_degree_name">{{ org.cour_degree_name }}</span>
                        <span v-else>NA</span>
                      </p>
                      <p class="programs">{{ org.org_country }}</p>
                    </div>
                  </template>
                </iq-card>
              </div>
            </b-row>
            <b-row>
              <b-col sm="7" md="8" class="my-1">
                <b-btn variant="primary" @click="loadMore" v-if="showLoadMoreBtn">Load More</b-btn>
              </b-col>
            </b-row>
          </div>
          <div v-else class="p-2 text-center flex flex-fill justify-content-center">
            No Data Found
          </div>
        </tab-content-item>

        <b-toast v-model="showToast" name="Toast" :variant="toastVariant" :title="toastTitle">
          <div v-html="toastMsg">
          </div>
        </b-toast>
      </b-col>
    </b-row>
  </b-container>
</template>
<style scoped >
  .iq-card-stretch{
    border-radius: 20px;
  }
  .followButton{
    min-height: unset;
    max-height: 50px;
  }
  .badges-icon {
    position: relative;
  }
  .status{
    position: absolute;
    bottom: 0;
    right: 0;
  }
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<script>
import { socialvue } from "../../../config/pluginInit"
import { Organisations } from "../../../FackApi/api/organisation.js"
import { UniversityCourses } from "../../../FackApi/api/universityCourse.js"
import Multiselect from "vue-multiselect"

export default {
  name: "CourseFinder",
  components: {
    Multiselect
  },
  data () {
    return {
      cvCardTitle: "Course Finder",
      organisationListObj: {},
      currentPage: 1,
      showLoadMoreBtn: false,
      showToast: false,
      toastMsg: null,
      toastVariant: "default",
      toastTitle: "Course Finder",
      cvSelectBoxText: "Search Course",
      cvOrganisationResp: [],
      cvcareerCourseOptions: [],
      courseLimit: 100,
      orgLimit: 100,
      dataPerPage: 100,
      selectedCourse: "",
      cvSelectorg: "Select University",
      countryList: [],
      cvUnivOptions: [],
      cvSearchText: "Search Course, Country or University Name",
      orgName: null,
      whereFilter: {
        "country": "null",
        "org_id": null,
        "cour_name": null
      }
    }
  },
  computed: {
    userData () {
      return this.$store.getters["User/userData"]
    },
    universities () {
      return this.$store.getters["Universities/selectedUniversity"]
    }
  },
  watch: {
    "$route.path": function (newPath, oldPath) {
      this.refreshPage = newPath
      this.organisationListObj = {}
      this.currentPage = 1
      this.loadRequiredData()
    }
  },
  beforeMount () {
  },
  async mounted () {
    this.loadRequiredData()
  },
  methods: {
    /**
     * set Filters
     */
    setFilter (filterName = null, filter = null) {
      this.currentPage = 1

      this.whereFilter.cour_name = null
      this.whereFilter.country = null
      this.whereFilter.org_id = null

      if (filterName == "course") {
        this.whereFilter.cour_name = filter.cour_name
      }
      else if (filterName == "country") {
        this.whereFilter.country = filter
      }
      else if (filterName == "university") {
        this.whereFilter.org_id = filter.org_id
      }

      this.courseList(false)
    },
    /**
     * searchCourseParams
     */
    async searchCourseParams () {
      if (this.whereFilter.search_param.length <= 3) {
        return
      }
      this.courseList(false)
    },
    /**
     * loadRequiredData
     */
    async loadRequiredData () {
      socialvue.index()
      this.orgCountryList()
      this.careerCourseList()
      this.organisationNameFilterList()
      this.courseList(false)
    },
    /**
     * loadMore()
     */
    loadMore () {
      try {
        let currPage = this.currentPage
        this.currentPage = parseInt(currPage) + 1

        this.courseList(true)
      }
      catch (err) {
        console.error("Exception occured at loadMore() and Exception", err.message)
      }
    },
    /**
    },
    /**
     * goToOrganisationCourses
     */
    goToOrganisationCourses (orgId) {
      this.$router.push(`/organisationCourse_list/` + orgId)
    },
    /**
     * careerCourseList
     */
    async careerCourseList () {
      const filter = {
        limit: this.courseLimit
      }

      let organisationCareerCourseListResp = await UniversityCourses.organisationCourseList(this, filter, 1)

      if (organisationCareerCourseListResp.resp_status) {
        this.cvcareerCourseOptions = Object.keys(organisationCareerCourseListResp.resp_data.data).map((key) => organisationCareerCourseListResp.resp_data.data[key])
      }
    },
    /**
     * SearchOrganisationList
     */
    async SearchcareerCourseList (searchString) {
      if (!searchString || searchString.trim().length < 1) {
        return
      }

      if (searchString.length < 3) {
        return
      }

      if (searchString.toLowerCase() === "school" || searchString.toLowerCase() === "schoo" || searchString.toLowerCase() === "schoo" || searchString.toLowerCase() === "sch") {
        this.toastMsg = "Please enter your course name."
        this.toastVariant = "danger"
        this.showToast = true
        return
      }

      const filter = {
        search: searchString.trim()
      }

      let careerCourseListResp = await UniversityCourses.SearchcareerCourseList(this, filter)
      if (careerCourseListResp.resp_status) {
        this.cvOrganisationResp = careerCourseListResp.resp_data.data
        this.cvcareerCourseOptions = this.cvOrganisationResp.map(cour => ({
          cour_name: cour.cour_name
        }))
      }
    },
    /*
     * course Orgnisation List
     * */
    async courseList (loadViaLoadMore = false) {
      try {
        this.whereFilter.currentPage = this.currentPage
        this.whereFilter.dataPerPage = this.dataPerPage

        if (this.whereFilter.search_param && this.whereFilter.search_param.length >= 0) {
          this.whereFilter.cour_name = null
          this.whereFilter.country = null
          this.whereFilter.org_id = null
        }

        let courseOrgListResp = await UniversityCourses.courseOrgnisationList(this, this.whereFilter)
        if (courseOrgListResp && courseOrgListResp.resp_status) {
          if (!loadViaLoadMore) {
            this.organisationListObj = [ ...courseOrgListResp.resp_data.data ]
          }
          else {
            this.organisationListObj = [ ...this.organisationListObj, ...courseOrgListResp.resp_data.data ]
          }

          this.showLoadMoreBtn = true
        }
        else {
          this.showLoadMoreBtn = false
        }
      }
      catch (err) {
        console.error("Exception occurred at courseOrgnisationList() and Exception:", err.message)
        this.showLoadMoreBtn = false
      }
    },
    /**
     * org Country List
     */
    async orgCountryList () {
      try {
        let orgCountryListResp = await Organisations.organisation_country_list(this, { type: "UNIV" })
        if (orgCountryListResp.resp_status) {
          this.org_countryObjList = orgCountryListResp.resp_data.data
          this.countryList = this.org_countryObjList.map(e => ({ country: e.org_country }))
        }
        else {
          this.toastMsg = orgCountryListResp.resp_msg
          this.toastVariant = "danger"
          this.showToast = true
        }
      }
      catch (err) {
        console.log("Exception occurred at orgCountryList() and Exception:", err.message)
      }
    },
    /**
     * Organisation List
     */
    async organisationNameFilterList (searchString = null) {
      let filter = {}
      let limit = this.orgLimit

      if (searchString && searchString.trim().length >= 4) {
        filter.search = searchString.trim()
      }

      filter.fields = [ "org_name", "org_city", "org_country", "org_uid" ]
      filter.type = ["UNIV"]

      const list = await Organisations.organisationListSearch(this, filter, limit)
      if (list.resp_status) {
        this.cvUnivOptions = list.resp_data.data
      }
    }
  }
}
</script>
<style lang="scss">
  .orgDetails .org_name{
    font-size: 16px;
    font-weight: 500;
    color: #000;
    margin:0px;
    margin-bottom: 5px;
    line-height: 25px;
  }
  .orgDetails .org_ra{
    font-size: 15px;
    color: #000;
    margin-bottom: 0px;
    span{
      color:#777;
    }
  }
  .orgDetails .programs{
    margin: 0px;
    color: #000;
    span{
      color:#777;
    }
  }
</style>
